import styled from 'styled-components';

import { units } from '@calm-web/design-system';

export const Wrapper = styled.div<{ isPaymentPage: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: ${p => (p.isPaymentPage ? 0 : units(1))};
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-items: center;
	align-items: center;
	max-width: 600px;
	margin-top: ${units(3)};
`;
